import { v5 as uuidv5 } from 'uuid';

const CANVAS_EDGE_NAMESPACE = '83f1f1c8-7e7b-4ce1-bb56-83b97c41b1bb';

export interface CanvasEdgeIdentityLike {
  id?: string | null;
  source: string;
  target: string;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  relationType?: string | null;
  relationLabel?: string | null;
}

function normalizeCanvasEdgeIdentityPart(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function buildCanvasEdgeSemanticKey(edge: Omit<CanvasEdgeIdentityLike, 'id'>): string {
  return [
    normalizeCanvasEdgeIdentityPart(edge.source),
    normalizeCanvasEdgeIdentityPart(edge.target),
    normalizeCanvasEdgeIdentityPart(edge.sourceHandle),
    normalizeCanvasEdgeIdentityPart(edge.targetHandle),
    normalizeCanvasEdgeIdentityPart(edge.relationType),
    normalizeCanvasEdgeIdentityPart(edge.relationLabel),
  ].join('::');
}

export function buildCanonicalCanvasEdgeId(edge: Omit<CanvasEdgeIdentityLike, 'id'>): string {
  return uuidv5(buildCanvasEdgeSemanticKey(edge), CANVAS_EDGE_NAMESPACE);
}

export function buildCanvasEdgesSignature(edges: CanvasEdgeIdentityLike[]): string {
  return edges
    .map((edge) => [
      normalizeCanvasEdgeIdentityPart(edge.id),
      buildCanvasEdgeSemanticKey(edge),
    ].join('::'))
    .sort()
    .join('|');
}